import { trace } from 'owa-trace';
import {
    addMinutes,
    getISOStringWithOffset,
    getTimestamp,
    isEqual,
    OwaDate,
    startOfDay,
    userDate,
    utcDate,
} from 'owa-datetime';
import { getTimeZoneOffset } from 'owa-datetime-store';
/**
 * get display date and if it's midnight
 * @isTimeInMidnight - is dateTimeToParse in midnight
 * @dateTimeToDisplay - the display date. To avoid bugs, need to take into account TimeZone Offset
 */
export default function getDisplayDateData(
    dateTimeToParse: string
): { isTimeInMidnight: boolean; dateTimeToDisplay: string } {
    let eventUtcDate: OwaDate;

    try {
        eventUtcDate = utcDate(dateTimeToParse);
    } catch {
        // owaDate can't create an owaDate from the string
        trace.error('Cannot create owaDate from datetime to be parsed: ' + dateTimeToParse);
        return null;
    }
    let eventDisplayDate: OwaDate;

    try {
        // We use a negation of the offset when creating an owaDate, otherwise the dates will be incorrect
        // See: owaDate's AdjustedDate
        const offset = getTimeZoneOffset(getTimestamp(eventUtcDate));
        eventDisplayDate = userDate(addMinutes(eventUtcDate, -offset));
    } catch {
        // If no offset exists we assume that the date is a UTC date
        eventDisplayDate = eventUtcDate;
    }

    const eventDateTimeString = getISOStringWithOffset(eventDisplayDate);
    // Is there a time part to this date? i.e. Is time at midnight?
    const midnight = startOfDay(eventDisplayDate);
    const txpIsEqual = isEqual(midnight, eventDisplayDate);

    return {
        isTimeInMidnight: txpIsEqual,
        dateTimeToDisplay: eventDateTimeString,
    };
}
